/* global G */
import { curry } from 'lib/util'
import persistOptions from 'app/_shared/events/persist/options'
import { actionWithHooks } from 'lib/sequence/module/action'

/**
 * Event Handler Select and Action
 *
 * It executes persistOptions event handler,
 * followed by module action sequence actionWithHooks()
 *
 * It used in cases, where you want to reapply changes to UI, based on provided selection
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {Event} event                 the event object that triggered this handler
 * @returns {Promise<void>}
 */
const selectAndAction = async (module, component, event) => {
  try {
    const { item } = event.detail
    persistOptions(module, component, event)
    // call same action, see side effects
    await actionWithHooks(module[G.STATE][G.ACTION])(item)
  } catch (e) {
    console.error(e)
  }
}

export default curry(selectAndAction)
